import { defineClassNames } from '../utils/defineClassNames';

export const classes = defineClassNames('clickable-card', {
  root: {
    variants: {
      skin: ['standard', 'shadow', 'outline', 'filled'],
    },
    states: ['hasPadding', 'disabled'],
  },
  clickableOverlay: {},
});
